import { LibraryDatasetTable } from '@/components'
import { config } from '@/config'
import { DatasetSimple } from '@/interfaces'

import { useOtherBessInputs } from '../hooks'

interface Props {
  datasets: DatasetSimple[]
}

export const OtherBessInputsDatasetsTable = ({ datasets }: Props) => {
  const { cloneDataset, isCloneDatasetInProgress, removeDataset } =
    useOtherBessInputs()

  const allDatasetNames = datasets.map(x => x.name || '')

  return (
    <LibraryDatasetTable
      datasets={datasets}
      getDetailsLink={datasetId =>
        `${config.links.library.otherBessInputs}/${datasetId}`
      }
      isCloneInProgress={isCloneDatasetInProgress}
      onRemoveClicked={datasetId => removeDataset(datasetId)}
      onCloneClicked={(datasetId, datasetName, onSuccess) =>
        cloneDataset({ datasetId, name: datasetName }, { onSuccess })
      }
      allDatasetNames={allDatasetNames}
    />
  )
}
